export default __webpack_public_path__ + "static/meta-image-5effe3fc4cd997bb00366a23276481e6.png";